<template>
  <div
    class="container"
    v-bind:style="{ backgroundColor: options.chartArea.backgroundColor }"
  >
    <br />
    <h1
      v-if="sum"
      class="title is-pulled-right"
      style="color: white; margin-right: 2em"
    >
      {{ sum }}
    </h1>
    <p
      style="text-align: left; margin-left: 2em; color: white; font-size: 1.5em"
    >
      {{ title }}
    </p>
    <br />
    <canvas ref="canvas" width="900" height="300"></canvas>
  </div>
</template>

<script>
import { Bar, mixins } from "vue-chartjs";

export default {
  extends: Bar,
  name: "consumption",
  mixins: [mixins.reactiveProp],
  props: ["chartData", "options", "title", "sum"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>

<style lang="scss" scoped>
.container {
}
</style>
